export default {
  'stock.minimumStock.form.companies': 'Empresas',
  'stock.minimumStock.form.displayMinimumStock':
    'Exibir Peças e/ou insumos com Estoque Mínimo',
  'stock.minimumStock.form.belowStock':
    'Exibir Peças e/ou insumos Abaixo do Estoque Mínimo',
  'stock.minimumStock.form.isActiveItems': 'Exibir Peças e/ou insumos Ativos',
  'stock.minimumStock.form.isInactiveItems':
    'Exibir Peças e/ou insumos Inativos',
  'stock.minimumStock.form.partTypes': 'Tipo Peças',
  'stock.minimumStock.form.partTypes.parts': 'Peças',
  'stock.minimumStock.form.partTypes.inputs': 'Insumos',

  'stock.minimumStock.form.filterBy': 'Filtrar por',
  'stock.minimumStock.form.filterBy.internalCode': 'Código Interno',
  'stock.minimumStock.form.filterBy.manufacturingCode': 'Código de Fabricação',
  'stock.minimumStock.form.filterBy.barCode': 'Código de Barras',
  'stock.minimumStock.form.filterBy.description': 'Descrição',
  'stock.minimumStock.form.filterBy.manufacturer': 'Fabricante',
  'stock.minimumStock.form.filterBy.group': 'Grupo',
  'stock.minimumStock.form.filterBy.subGroup': 'Subgrupo',

  'stock.minimumStock.form.in': 'De:',
  'stock.minimumStock.form.upUntil': 'Até:',
};
